var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "Confirm order",
        visible: _vm.visible,
        width: "500px",
        top: "30px",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "form",
          attrs: { model: _vm.form, rules: _vm.rules, "label-position": "top" },
          nativeOn: {
            submit: function ($event) {
              $event.preventDefault()
              return false($event)
            },
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "Approved quantity", prop: "realAmount" } },
            [
              _c("el-input", {
                staticClass: "input-number",
                attrs: { type: "number", size: "normal" },
                model: {
                  value: _vm.form.realAmount,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "realAmount", $$v)
                  },
                  expression: "form.realAmount",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "span",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  _vm.visible = false
                },
              },
            },
            [_vm._v("Cancel")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary", loading: _vm.loading },
              on: { click: _vm.submitData },
            },
            [_vm._v("Submit")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }